module.exports = __webpack_public_path__ + "img/logo-phire.02327e60.png";